// src/components/Breadcrumb.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumb({ categoria, nombre }) {
  return (
    <nav className="text-sm text-gray-600 mb-4">
      <ul className="flex items-center space-x-2">
        <li>
          <Link to="/" className="hover:underline text-blue-600">Inicio</Link>
        </li>

        {categoria && (
          <>
            <li>/</li>
            <li className="text-gray-800 font-medium capitalize">{categoria}</li>
          </>
        )}

        {!categoria && nombre && (
          <>
            <li>/</li>
            <li className="text-gray-800 font-medium">
              Resultados para "<span className="italic">{nombre}</span>"
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}

